import { lazy } from "react";
import { encryptStorage } from "./helpers";
import { Navigate } from "react-router-dom";

const DashboardPage = lazy(() => import("./pages/dashboard"));
const StaffPage = lazy(() => import("./pages/staff"));
const StaffMultiStep = lazy(() => import("./pages/staff/multiStep"));
const ProfilePage = lazy(() => import("./pages/profile"));
const MasterChiefPage = lazy(() => import("./pages/master/chief"));
const MasterSignature = lazy(() => import("./pages/master/signature"));
const MasterSalaryName = lazy(() => import("./pages/master/salaryName"));
const MasterDoesntHaveKelmeng = lazy(() => import("./pages/master/kelmeng"));
const MasterUMK = lazy(() => import("./pages/master/umk"));
const MasterPresence = lazy(() => import("./pages/master/presence"));
const MasterFormPresence = lazy(() => import("./pages/master/presence/form"));
const MasterSubUnit = lazy(() => import("./pages/master/subUnit"));
const MasterUnitPage = lazy(() => import("./pages/master/unit"));
const MasterPositions = lazy(() => import("./pages/master/position"));
const MasterAssessmentPeriod = lazy(() => import("./pages/master/assesmentPeriod"));
const MasterSupervisor = lazy(() => import("./pages/master/supervisor"));
const MasterSupervisorForm = lazy(() => import("./pages/master/supervisor/form"));
const MasterHierarchyPosition = lazy(() => import("./pages/master/hierarchyPosition"));
const MasterHierarchyPositionForm = lazy(() => import("./pages/master/hierarchyPosition/form"));
const MasterPositionRole = lazy(() => import("./pages/master/positionRole"));
const MasterPositionRoleForm = lazy(() => import("./pages/master/positionRole/form"));
const ReportPayrollPage = lazy(() => import("./pages/report/payroll"));
const ReportRapelPage = lazy(() => import("./pages/report/rapel"));
const ReportStaffPage = lazy(() => import("./pages/report/staff"));
const ReportEmploymentHistory = lazy(() => import("./pages/report/historyStaff"));
const EmploymentHistoryDetail = lazy(() => import("./pages/report/historyStaff/detail"));
const RapelSalary = lazy(() => import("./pages/rapel/salary"));
const RapelFamily = lazy(() => import("./pages/rapel/family"));
const RapelStructural = lazy(() => import("./pages/rapel/structural"));
const RapelFunctional = lazy(() => import("./pages/rapel/functional"));
const RapelHtr = lazy(() => import("./pages/rapel/htr"));
const PayrollHtr = lazy(() => import("./pages/payroll/htr"));
const PayrollDesductionStaff = lazy(() => import("./pages/payroll/deductionStaff"));
const PayrollBpjsKesehatan = lazy(() => import("./pages/payroll/bpjsKesehatan"));
const PayrollBpjsKetenagakerjaan = lazy(() => import("./pages/payroll/bpjsKetenagakerjaan"));
const PayrollTopUpYadapen = lazy(() => import("./pages/payroll/yadapen"));
const PayrollContributionStaff = lazy(() => import("./pages/payroll/contributionStaff"));
const PayrollDesductionOther = lazy(() => import("./pages/payroll/deductionOther"));
const PayrollPph = lazy(() => import("./pages/payroll/pph21"));
const PayrollSlip = lazy(() => import("./pages/payroll/salary"));
const PayrollSlipDetail = lazy(() => import("./pages/payroll/salary/detail"));
const PayrollSlipPreview = lazy(() => import("./pages/payroll/salary/detail/preview"));
const AssessmentForm = lazy(() => import("./pages/assessment/form"));
const AssessmentFormContent = lazy(() => import("./pages/assessment/form/content"));
const AssementStaffPptt = lazy(() => import("./pages/assessment/pptt"));
const AssessmentAnswerPptt = lazy(() => import("./pages/assessment/pptt/form"));
const AssessmentPreviewPptt = lazy(() => import("./pages/assessment/pptt/preview"));
const AssementStaffSkp = lazy(() => import("./pages/assessment/skp"));
const AssessmentAnswerSkp = lazy(() => import("./pages/assessment/skp/form"));
const AssessmentPreviewSkp = lazy(() => import("./pages/assessment/skp/preview"));
const AssementStaffActionSkp = lazy(() => import("./pages/assessment/actionSkp"));
const AssessmentPreviewActionSkp = lazy(() => import("./pages/assessment/actionSkp/preview"));
const AssessmentActionSkpForm = lazy(() => import("./pages/assessment/actionSkp/form"));
const AssessmentNotificationPeriodicSalary = lazy(
  () => import("./pages/assessment/notification/periodicSalary"),
);
const AssessmentNotificationPromotion = lazy(
  () => import("./pages/assessment/notification/promotion"),
);
const AssessmentNotificationStatusChange = lazy(
  () => import("./pages/assessment/notification/statusChange"),
);
const AssessmentNotificationStatusChangeImporter = lazy(
  () => import("./pages/assessment/notification/statusChange/importer"),
);
const AssessmentResult = lazy(() => import("./pages/assessment/decree"));
const AssessmentResultPreview = lazy(() => import("./pages/assessment/decree/preview"));
const AssessmentResultForm = lazy(() => import("./pages/assessment/decree/form"));
const AssessmentRecapitulationPptt = lazy(() => import("./pages/assessment/recapitulation/pptt"));
const AssessmentRecapitulationSkp = lazy(() => import("./pages/assessment/recapitulation/skp"));
const AssessmentRecapitulationAll = lazy(
  () => import("./pages/assessment/recapitulation/supervision"),
);
const ViewOldDecree = lazy(() => import("./pages/decree/old"));
const ViewOldStatus = lazy(() => import("./pages/assessment/notification/statusChange/oldStatus"));
const ViewAsessmentDirectSupervisor = lazy(() => import("./pages/assessment/directSupevisor"));
const AssessmentDirectSupervisorForm = lazy(
  () => import("./pages/assessment/directSupevisor/form"),
);
const AssessmentPreviewDirectSupervisor = lazy(
  () => import("./pages/assessment/directSupevisor/preview"),
);
const ViewAsessmentSupervisor = lazy(() => import("./pages/assessment/supervisor"));
const AssessmentSupervisorForm = lazy(() => import("./pages/assessment/supervisor/form"));
const AssessmentPreviewSupervisor = lazy(() => import("./pages/assessment/supervisor/preview"));
const AssessmentPromotion = lazy(() => import("./pages/assessment/promotion"));
const AssessmentStatusChange = lazy(() => import("./pages/assessment/statusChange"));

const DecreePage = lazy(() => import("./pages/decree"));
const DecreePreview = lazy(() => import("./pages/decree/preview"));
const DecreeFormPage = lazy(() => import("./pages/decree/form"));
const AssignmentPage = lazy(() => import("./pages/assignment"));
const AssignmentPreview = lazy(() => import("./pages/assignment/preview"));
const AssignmentFormPage = lazy(() => import("./pages/assignment/form"));
const SubmissionStructural = lazy(() => import("./pages/structuralPosition"));
const SubmissionTeachingSchedule = lazy(() => import("./pages/teachingSchedule"));
const StaffRequisitionPage = lazy(() => import("./pages/staffingRequisition"));
const RekapKebutuhanPegawaiPage = lazy(() => import("./pages/staffingRequisition/rekap"));
const PermohonanMutasiPage = lazy(() => import("./pages/staffingRequisition/permohonanMutasi"));
const PermohonanResignPage = lazy(() => import("./pages/staffingRequisition/permohonanResign"));

const Authorized = ({ component, permission }) => {
  const { permissions: permissions2, is_custom } = encryptStorage.getItem("personalia-user");
  let finalPermission;
  if (parseInt(is_custom, 10) === 1) {
    finalPermission = permissions2;
  } else {
    const permissions =
      encryptStorage
        .getItem("personalia-roles")
        ?.filter((data) => data?.appCode === "personalia") || [];
    const permissionConcat = permissions?.map((item) => item?.permissions)?.flat();
    const permissionUnique = [...new Set(permissionConcat)];
    finalPermission = permissionUnique;
  }
  const auth = finalPermission?.includes(permission);
  if (!auth) {
    return <Navigate to="/401" />;
  }
  return component;
};

const RouteList = [
  {
    path: "/",
    label: "Beranda",
    element: <DashboardPage />,
  },
  {
    path: "/beranda",
    label: "Beranda",
    element: <DashboardPage />,
  },
  {
    path: "/data-staff",
    label: "Data Pegawai",
    element: <Authorized component={<StaffPage />} permission="data_staff" />,
  },
  {
    path: "/data-staff/tambah",
    label: "Tambah Pegawai",
    element: <Authorized component={<StaffMultiStep />} permission="add_staff" />,
  },
  {
    path: "/data-staff/lihat",
    label: "Detail Pegawai",
    element: <StaffMultiStep isView />,
  },
  {
    path: "/data-staff/edit",
    label: "Edit Pegawai",
    element: <Authorized component={<StaffMultiStep isEdit />} permission={"edit_staff"} />,
  },
  {
    path: "/profile",
    label: "Pengaturan Akun",
    element: <ProfilePage />,
  },
  {
    path: "/data-staff/surat-keputusan",
    label: "Surat Keputusan",
    element: <Authorized component={<DecreePage />} permission="view_sk" />,
  },
  {
    path: "/data-staff/surat-keputusan/pratinjau",
    label: "Pratinjau",
    element: <Authorized component={<DecreePreview />} permission="view_sk" />,
  },
  {
    path: "/data-staff/surat-keputusan/tambah",
    label: "Tambah",
    element: <Authorized component={<DecreeFormPage />} permission="edit_sk" />,
  },
  {
    path: "/data-staff/surat-keputusan/edit",
    label: "Pembaruan",
    element: <Authorized component={<DecreeFormPage isEdit />} permission="edit_sk" />,
  },
  {
    path: "/data-staff/surat-tugas",
    label: "Surat Tugas",
    element: <Authorized component={<AssignmentPage />} permission="view_st" />,
  },
  {
    path: "/data-staff/surat-tugas/pratinjau",
    label: "Pratinjau",
    element: <Authorized component={<AssignmentPreview />} permission="view_st" />,
  },
  {
    path: "/data-staff/surat-tugas/tambah",
    label: "Tambah",
    element: <Authorized component={<AssignmentFormPage />} permission="edit_st" />,
  },
  {
    path: "/data-staff/surat-tugas/edit",
    label: "Pembaruan",
    element: <Authorized component={<AssignmentFormPage isEdit />} permission="edit_st" />,
  },
  {
    path: "/pengajuan",
    label: "Pengajuan",
    element: <DashboardPage />,
  },
  {
    path: "/pengajuan/jabatan-struktural",
    label: "Jabatan Struktural",
    element: (
      <Authorized component={<SubmissionStructural />} permission="view_structural_position" />
    ),
  },
  {
    path: "/pengajuan/kelebihan-mengajar",
    label: "Kelebihan Mengajar",
    element: (
      <Authorized component={<SubmissionTeachingSchedule />} permission="view_teaching_schedule" />
    ),
  },
  {
    path: "/kebutuhan-pegawai",
    label: "Kebutuhan Pegawai",
    element: (
      <Authorized component={<StaffRequisitionPage />} permission={"view_staff_requisition"} />
    ),
  },
  {
    path: "/permohonan/mutasi",
    label: "Permohonan Mutasi",
    element: (
      <Authorized component={<PermohonanMutasiPage />} permission="view_permohonan_mutasi" />
    ),
  },
  {
    path: "/permohonan/resign",
    label: "Permohonan Resign",
    element: (
      <Authorized component={<PermohonanResignPage />} permission="view_permohonan_resign" />
    ),
  },
  {
    path: "/penilaian",
    label: "Penilaian",
    element: <DashboardPage />,
  },
  {
    path: "/penilaian/form",
    label: "Formulir",
    element: <Authorized component={<AssessmentForm />} permission="view_assessment_form" />,
  },
  {
    path: "/penilaian/sk-lama",
    label: "SK Lama",
    element: <Authorized component={<ViewOldDecree />} permission="view_old_decree" />,
  },
  {
    path: "/penilaian/st-lama",
    label: "ST Lama",
    element: <Authorized component={<ViewOldStatus />} permission="view_old_status" />,
  },
  {
    path: "/penilaian/dp3",
    label: "DP3",
    element: <Authorized component={<AssementStaffSkp />} permission="view_skp" />,
  },
  {
    path: "/penilaian/dp3/isi",
    label: "Nilai",
    element: <Authorized component={<AssessmentAnswerSkp isEdit />} permission="input_skp" />,
  },
  {
    path: "/penilaian/dp3/rincian",
    label: "Rincian Nilai",
    element: <Authorized component={<AssessmentAnswerSkp isView />} permission="view_skp" />,
  },
  {
    path: "/penilaian/dp3/pratinjau",
    label: "Pratinjau",
    element: <Authorized component={<AssessmentPreviewSkp />} permission="view_skp" />,
  },
  {
    path: "/penilaian/pptt",
    label: "PPTT",
    element: <Authorized component={<AssementStaffPptt />} permission="view_pptt" />,
  },
  {
    path: "/penilaian/pptt/isi",
    label: "Nilai",
    element: <Authorized component={<AssessmentAnswerPptt isEdit />} permission="input_pptt" />,
  },
  {
    path: "/penilaian/pptt/rincian",
    label: "Rincian Nilai",
    element: <Authorized component={<AssessmentAnswerPptt isView />} permission="view_pptt" />,
  },
  {
    path: "/penilaian/pptt/pratinjau",
    label: "Pratinjau",
    element: <Authorized component={<AssessmentPreviewPptt />} permission="view_pptt" />,
  },
  {
    path: "/penilaian/aksi-dp3",
    label: "Tindak Lanjut DP3",
    element: <Authorized component={<AssementStaffActionSkp />} permission="view_action_skp" />,
  },
  {
    path: "/penilaian/aksi-dp3/pratinjau",
    label: "Pratinjau",
    element: <Authorized component={<AssessmentPreviewActionSkp />} permission="view_action_skp" />,
  },
  {
    path: "/penilaian/aksi-dp3/tambah",
    label: "Nilai Baru",
    element: <Authorized component={<AssessmentActionSkpForm />} permission="input_skp" />,
  },
  {
    path: "/penilaian/aksi-dp3/edit",
    label: "Edit",
    element: <Authorized component={<AssessmentActionSkpForm isEdit />} permission="input_skp" />,
  },
  {
    path: "/penilaian/aksi-dp3/rincian",
    label: "Rincian",
    element: <Authorized component={<AssessmentActionSkpForm isView />} permission="view_skp" />,
  },

  {
    path: "/penilaian/atasan-langsung",
    label: "Atasan Langsung",
    element: (
      <Authorized component={<ViewAsessmentDirectSupervisor />} permission="view_head_assessment" />
    ),
  },
  {
    path: "/penilaian/atasan-langsung/tambah",
    label: "Tambah",
    element: (
      <Authorized
        component={<AssessmentDirectSupervisorForm />}
        permission="input_direct_supervisor_assessment"
      />
    ),
  },
  {
    path: "/penilaian/atasan-langsung/edit",
    label: "Edit",
    element: (
      <Authorized
        component={<AssessmentDirectSupervisorForm isEdit />}
        permission="input_direct_supervisor_assessment"
      />
    ),
  },
  {
    path: "/penilaian/atasan-langsung/pratinjau",
    label: "Pratinjau",
    element: (
      <Authorized
        component={<AssessmentPreviewDirectSupervisor />}
        permission="view_head_assessment"
      />
    ),
  },
  {
    path: "/penilaian/atasan-langsung/rincian",
    label: "Rincian",
    element: (
      <Authorized
        component={<AssessmentDirectSupervisorForm isView />}
        permission="view_head_assessment"
      />
    ),
  },
  {
    path: "/penilaian/supervisi",
    label: "Supervisi",
    element: (
      <Authorized component={<ViewAsessmentSupervisor />} permission="view_supervisor_assessment" />
    ),
  },
  {
    path: "/penilaian/supervisi/tambah",
    label: "Tambah",
    element: (
      <Authorized
        component={<AssessmentSupervisorForm />}
        permission="input_supervisor_assessment"
      />
    ),
  },
  {
    path: "/penilaian/supervisi/edit",
    label: "Edit",
    element: (
      <Authorized
        component={<AssessmentSupervisorForm isEdit />}
        permission="input_supervisor_assessment"
      />
    ),
  },
  {
    path: "/penilaian/supervisi/pratinjau",
    label: "Pratinjau",
    element: (
      <Authorized
        component={<AssessmentPreviewSupervisor />}
        permission="view_supervisor_assessment"
      />
    ),
  },
  {
    path: "/penilaian/supervisi/rincian",
    label: "Rincian",
    element: (
      <Authorized
        component={<AssessmentSupervisorForm isView />}
        permission="view_supervisor_assessment"
      />
    ),
  },
  {
    path: "/penilaian/notifikasi",
    label: "Notifikasi",
    element: <Authorized component={<DashboardPage />} permission="view_assessment_notice" />,
  },
  {
    path: "/penilaian/notifikasi/kenaikan-pangkat",
    label: "Kenaikan Pangkat",
    element: (
      <Authorized
        component={<AssessmentNotificationPromotion />}
        permission="view_assessment_notice"
      />
    ),
  },
  {
    path: "/penilaian/notifikasi/perubahan-status",
    label: "Perubahan Status",
    element: (
      <Authorized
        component={<AssessmentNotificationStatusChange />}
        permission="view_assessment_notice"
      />
    ),
  },
  {
    path: "/penilaian/notifikasi/perubahan-status/import",
    label: "Import",
    element: (
      <Authorized
        component={<AssessmentNotificationStatusChangeImporter />}
        permission="view_assessment_notice"
      />
    ),
  },
  {
    path: "/penilaian/notifikasi/gaji-berkala",
    label: "Gaji Berkala",
    element: (
      <Authorized
        component={<AssessmentNotificationPeriodicSalary />}
        permission="view_assessment_notice"
      />
    ),
  },
  {
    path: "/penilaian/form/edit",
    label: "Konten",
    element: <Authorized component={<AssessmentFormContent />} permission="view_assessment_form" />,
  },
  {
    path: "/penilaian/hasil",
    label: "Draft SK",
    element: <Authorized component={<AssessmentResult />} permission="view_assessment_result" />,
  },
  {
    path: "/penilaian/hasil/pratinjau",
    label: "Pratinjau",
    element: (
      <Authorized component={<AssessmentResultPreview />} permission="view_assessment_result" />
    ),
  },
  {
    path: "/penilaian/hasil/edit",
    label: "Edit",
    element: <Authorized component={<AssessmentResultForm isEdit />} permission="edit_sk" />,
  },
  {
    path: "/penilaian/rekapitulasi",
    label: "Rekapitulasi",
    element: <DashboardPage />,
  },
  {
    path: "/penilaian/rekapitulasi/pptt",
    label: "PPTT",
    element: (
      <Authorized
        component={<AssessmentRecapitulationPptt />}
        permission="view_recapitulation_pptt"
      />
    ),
  },
  {
    path: "/penilaian/rekapitulasi/dppp",
    label: "DP3",
    element: (
      <Authorized
        component={<AssessmentRecapitulationSkp />}
        permission="view_recapitulation_skp"
      />
    ),
  },
  {
    path: "/penilaian/rekapitulasi/supervisi",
    label: "Supervisi",
    element: (
      <Authorized
        component={<AssessmentRecapitulationAll />}
        permission="view_recapitulation_supervision"
      />
    ),
  },
  {
    path: "/penilaian/kenaikan-pangkat",
    label: "Kenaikan Pangkat",
    element: (
      <Authorized component={<AssessmentPromotion />} permission="view_assessment_promotion" />
    ),
  },
  {
    path: "/penilaian/perubahan-status",
    label: "Perubahan Status",
    element: (
      <Authorized
        component={<AssessmentStatusChange />}
        permission="view_assessment_status_change"
      />
    ),
  },
  {
    path: "/master",
    pathBreadcumb: "/master",
    label: "Master",
    element: <DashboardPage />,
  },
  {
    path: "/master/ketua-yayasan",
    label: "Ketua Yayasan",
    element: <Authorized component={<MasterChiefPage />} permission="master" />,
  },
  {
    path: "/master/nama-tabel-gaji",
    label: "Nama Tabel Gaji",
    element: <Authorized component={<MasterSalaryName />} permission="master" />,
  },
  {
    path: "/master/sub-unit",
    label: "Sub Unit",
    element: <Authorized component={<MasterSubUnit />} permission="master" />,
  },
  {
    path: "/master/jabatan",
    label: "Jabatan",
    element: <Authorized component={<MasterPositions />} permission="master" />,
  },
  {
    path: "/master/unit",
    label: "Unit",
    element: <Authorized component={<MasterUnitPage />} permission="master" />,
  },
  {
    path: "/master/umk",
    label: "UMK",
    element: <Authorized component={<MasterUMK />} permission="master" />,
  },
  {
    path: "/master/tunjangan-kehadiran",
    label: "Tunjangan Kehadiran",
    element: <Authorized component={<MasterPresence />} permission="master" />,
  },
  {
    path: "/master/tunjangan-kehadiran/form",
    label: "Form Tunjangan Kehadiran",
    element: <Authorized component={<MasterFormPresence />} permission="master" />,
  },
  {
    path: "/master/tidak-dapat-kelmeng",
    label: "Tidak Dapat Kelmeng",
    element: <Authorized component={<MasterDoesntHaveKelmeng />} permission="master" />,
  },
  {
    path: "/master/tanda-tangan",
    label: "Tanda Tangan",
    element: <Authorized component={<MasterSignature />} permission="master" />,
  },
  {
    path: "/master/periode-penilaian",
    label: "Periode Penilaian",
    element: (
      <Authorized component={<MasterAssessmentPeriod />} permission="master_assessment_period" />
    ),
  },
  {
    path: "/master/supervisor",
    label: "Supervisor",
    element: <Authorized component={<MasterSupervisor />} permission="master_supervisor" />,
  },
  {
    path: "/master/supervisor/tambah",
    label: "Tambah",
    element: <Authorized component={<MasterSupervisorForm />} permission={"master_supervisor"} />,
  },
  {
    path: "/master/supervisor/edit",
    label: "Edit",
    element: (
      <Authorized component={<MasterSupervisorForm isEdit />} permission={"master_supervisor"} />
    ),
  },
  {
    path: "/master/jabatan-atasan-langsung",
    label: "Jabatan Atasan Langsung",
    element: (
      <Authorized component={<MasterHierarchyPosition />} permission="master_hierarchy_position" />
    ),
  },
  {
    path: "/master/jabatan-atasan-langsung/tambah",
    label: "Tambah",
    element: (
      <Authorized
        component={<MasterHierarchyPositionForm />}
        permission={"master_hierarchy_position"}
      />
    ),
  },
  {
    path: "/master/jabatan-atasan-langsung/edit",
    label: "Edit",
    element: (
      <Authorized
        component={<MasterHierarchyPositionForm isEdit />}
        permission={"master_hierarchy_position"}
      />
    ),
  },
  {
    path: "/master/hak-akses-jabatan",
    label: "Hak Akses Jabatan",
    element: <Authorized component={<MasterPositionRole />} permission="view_position_role" />,
  },
  {
    path: "/master/hak-akses-jabatan/tambah",
    label: "Tambah",
    element: (
      <Authorized component={<MasterPositionRoleForm />} permission={"input_position_role"} />
    ),
  },
  {
    path: "/master/hak-akses-jabatan/edit",
    label: "Edit",
    element: (
      <Authorized
        component={<MasterPositionRoleForm isEdit />}
        permission={"input_position_role"}
      />
    ),
  },
  {
    path: "/penggajian",
    label: "Penggajian",
    element: <DashboardPage />,
  },
  {
    path: "/penggajian/potongan-lain-lain",
    label: "Potongan Lain-lain",
    element: (
      <Authorized component={<PayrollDesductionOther />} permission="input_potongan_intern" />
    ),
  },
  {
    path: "/penggajian/iuran-pegawai",
    label: "Iuran Pegawai",
    element: (
      <Authorized component={<PayrollContributionStaff />} permission={"input_potongan_yayasan"} />
    ),
  },
  {
    path: "/penggajian/piutang-pegawai",
    label: "Piutang Pegawai",
    element: (
      <Authorized
        component={<PayrollDesductionStaff />}
        permission="input_potongan_piutang_pegawai"
      />
    ),
  },
  {
    path: "/penggajian/potongan-pph21",
    label: "Potongan PPh 21",
    element: <Authorized component={<PayrollPph />} permission="input_potongan_pph21" />,
  },
  {
    path: "/penggajian/bpjs-kesehatan",
    label: "BPJS Kesehatan",
    element: <Authorized component={<PayrollBpjsKesehatan />} permission="input_bpjs_kesehatan" />,
  },
  {
    path: "/penggajian/bpjs-ketenagakerjaan",
    label: "BPJS Ketenagakerjaan",
    element: (
      <Authorized
        component={<PayrollBpjsKetenagakerjaan />}
        permission="input_bpjs_ketenagakerjaan"
      />
    ),
  },
  {
    path: "/penggajian/topup-yadapen",
    label: "Top Up Yadapen",
    element: <Authorized component={<PayrollTopUpYadapen />} permission="topup_yadapen" />,
  },
  {
    path: "/penggajian/slip",
    label: "Slip Gaji",
    element: <Authorized component={<PayrollSlip />} permission="slip_gaji" />,
  },
  {
    path: "/penggajian/slip/rincian",
    label: "Rincian",
    element: <Authorized component={<PayrollSlipDetail />} permission="slip_gaji" />,
  },
  {
    path: "/penggajian/slip/rincian/pratinjau",
    label: "Pratinjau",
    element: <Authorized component={<PayrollSlipPreview />} permission="slip_gaji" />,
  },
  {
    path: "/penggajian/honor-tidak-rutin",
    label: "Honor Tidak Rutin",
    element: <Authorized component={<PayrollHtr />} permission="input_honor_tidak_rutin" />,
  },
  {
    path: "/rapel",
    label: "Rapel",
    element: <DashboardPage />,
  },
  {
    path: "/rapel/gaji",
    label: "Gaji",
    element: <Authorized component={<RapelSalary />} permission="rapel_salary" />,
  },
  {
    path: "/rapel/tunjangan-keluarga",
    label: "Tunjangan Keluarga",
    element: <Authorized component={<RapelFamily />} permission="rapel_family" />,
  },
  {
    path: "/rapel/tunjangan-struktural",
    label: "Tunjangan Struktural",
    element: <Authorized component={<RapelStructural />} permission="rapel_struktural" />,
  },
  {
    path: "/rapel/tunjangan-fungsional",
    label: "Tunjangan Fungsional",
    element: <Authorized component={<RapelFunctional />} permission="rapel_fungsional" />,
  },
  {
    path: "/rapel/honor-tidak-rutin",
    label: "Honor Tidak Rutin",
    element: <Authorized component={<RapelHtr />} permission="rapel_honor_tidak_rutin" />,
  },
  {
    path: "/laporan",
    label: "Laporan",
    element: <DashboardPage />,
  },
  {
    path: "/laporan/penggajian",
    label: "Gaji",
    element: <Authorized component={<ReportPayrollPage />} permission="view_payroll_report" />,
  },
  {
    path: "/laporan/rapel",
    label: "Rapel",
    element: <Authorized component={<ReportRapelPage />} permission="view_payroll_report" />,
  },
  {
    path: "/laporan/riwayat-pekerjaan",
    label: "Riwayat Pekerjaan",
    element: (
      <Authorized component={<ReportEmploymentHistory />} permission="employment_history_report" />
    ),
  },
  {
    path: "/laporan/riwayat-pekerjaan/rincian",
    label: "Rincian",
    element: (
      <Authorized component={<EmploymentHistoryDetail />} permission="employment_history_report" />
    ),
  },
  {
    path: "/laporan/pegawai",
    label: "Pegawai",
    element: <Authorized component={<ReportStaffPage />} permission="view_staff_report" />,
  },
  {
    path: "/laporan/kebutuhan-pegawai",
    label: "Rekap Kebutuhan Pegawai",
    element: (
      <Authorized
        component={<RekapKebutuhanPegawaiPage />}
        permission={"view_staff_requisition_report"}
      />
    ),
  },
  // {
  //   path: "/pengaturan",
  //   label: "Pengaturan",
  //   element: <DashboardPage />,
  // },
  // {
  //   path: "/pengaturan/catatan",
  //   label: "Audit Log",
  //   element: <AuditLogPage />,
  // },
];

export default RouteList;
